import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { _T, C } from '../shared/theme';
import { s_PB, s_PL } from '../shared/styles';
import { TIPS } from '../shared/constants';

function TipsModal({onClose,lang}) {
  const nl = lang==="nl";
  const tip = useRef(TIPS[Math.floor(Math.random()*TIPS.length)]).current;
  return ReactDOM.createPortal(
    <div style={{position:"fixed",inset:0,zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
      <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.6)"}}/>
      <div className="popIn" style={{position:"relative",zIndex:301,background:_T.bg2,border:`1px solid ${_T.cardBorderTop}`,borderRadius:24,padding:28,maxWidth:340,width:"100%"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
          <div style={{fontSize:13,color:_T.accent,letterSpacing:3,fontWeight:600}}>{nl?"TIP VAN DE DAG":"TIP OF THE DAY"}</div>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.silver,cursor:"pointer",fontSize:20}}>×</button>
        </div>
        <div style={{fontSize:42,marginBottom:12,textAlign:"center"}}>{tip.icon}</div>
        <div style={{fontFamily:"Georgia,serif",fontSize:18,color:C.white,marginBottom:10,textAlign:"center"}}>{tip.title}</div>
        <div style={{color:C.silver2,fontSize:14,lineHeight:1.8,textAlign:"center",marginBottom:20}}>{tip.tip}</div>
        <button style={s_PB({width:"100%"})} onClick={onClose}>{nl?"Begrepen!":"Got it!"}</button>
      </div>
    </div>,
    document.body
  );
}

export default TipsModal;
